import Loading from './presentational/Loading';
import ApplicationLoading from './container/ApplicationLoading';

export {
    Loading,
    ApplicationLoading
}


// WEBPACK FOOTER //
// ./src/components/loading/index.js